import { render, staticRenderFns } from "./MediaItemCard.vue?vue&type=template&id=43aabd6c&scoped=true&"
import script from "./MediaItemCard.vue?vue&type=script&lang=ts&"
export * from "./MediaItemCard.vue?vue&type=script&lang=ts&"
import style0 from "./MediaItemCard.vue?vue&type=style&index=0&id=43aabd6c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43aabd6c",
  null
  
)

export default component.exports